import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const PreviewContainer = styled.section`
  display: flex;
  margin: 10px 10px;
  flex-direction: column;
  cursor: pointer;
  @media (max-width: 360px) {
    margin: 10px 3px;
  }
`;

export const Item: any = styled.div`
  + div {
    margin-top: 26px;
  }
`;

export const ValuesContainer = styled.div`
  display: flex;
`;

Item.Title = styled.span`
  font-size: 14px;
  color: ${ColorPalette.HEX.PineTree};
`;

Item.Value = styled.span`
  font-size: 12px;
  color: ${ColorPalette.HEX.SonicSilver};
`;

export const Point = styled.span`
  padding: 0px 5px;
  font-family: Poppins;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${ColorPalette.HEX.SonicSilver};
`;
